(function() {
    const sectionScript = document.currentScript;
    if (!sectionScript) return;
    const sectionId = sectionScript.dataset.sectionId;
    const sectionRoot = sectionScript.closest('.shopify-section');
    const slider = sectionRoot?.querySelector('[data-slider-id="' + sectionId + '"]');

    if (!slider) return;
    if (slider.dataset.featureSliderInitialized === 'true') return;
    slider.dataset.featureSliderInitialized = 'true';

    const images = slider.querySelectorAll('.mp-top-feature__image');
    const contents = slider.querySelectorAll('.mp-top-feature__content');
    const prevButton = slider.querySelector('[data-nav-id="' + sectionId + '-prev"]');
    const nextButton = slider.querySelector('[data-nav-id="' + sectionId + '-next"]');

    let currentIndex = 0;
    const totalSlides = images.length;

    function updateSlide(newIndex) {
        if (newIndex < 0 || newIndex >= totalSlides) return;

        // 現在のスライドをフェードアウト
        images[currentIndex].classList.remove('active');
        contents[currentIndex].classList.remove('active');

        // 新しいスライドをフェードイン
        currentIndex = newIndex;
        images[currentIndex].classList.add('active');
        contents[currentIndex].classList.add('active');

        // ボタンの状態を更新
        updateButtons();
    }

    function updateButtons() {
        if (prevButton) {
            if (currentIndex === 0) {
                prevButton.classList.add('swiper-button-disabled');
                prevButton.disabled = true;
            } else {
                prevButton.classList.remove('swiper-button-disabled');
                prevButton.disabled = false;
            }
        }

        if (nextButton) {
            if (currentIndex === totalSlides - 1) {
                nextButton.classList.add('swiper-button-disabled');
                nextButton.disabled = true;
            } else {
                nextButton.classList.remove('swiper-button-disabled');
                nextButton.disabled = false;
            }
        }
    }

    // ボタンのイベントリスナーを追加
    if (prevButton) {
        prevButton.addEventListener('click', function() {
            updateSlide(currentIndex - 1);
        });
    }

    if (nextButton) {
        nextButton.addEventListener('click', function() {
            updateSlide(currentIndex + 1);
        });
    }

    // スワイプ・ドラッグ機能の追加
    let startX = 0;
    let endX = 0;
    let startY = 0;
    let endY = 0;
    let isDragging = false;
    const minSwipeDistance = 50; // スワイプと判定する最小距離

    // タッチイベント（スマホ・タブレット）
    slider.addEventListener('touchstart', function(e) {
        startX = e.changedTouches[0].screenX;
        startY = e.changedTouches[0].screenY;
    }, { passive: true });

    slider.addEventListener('touchend', function(e) {
        endX = e.changedTouches[0].screenX;
        endY = e.changedTouches[0].screenY;
        handleSwipe();
    }, { passive: true });

    // マウスイベント（PC）
    let hasMoved = false;

    slider.addEventListener('mousedown', function(e) {
        isDragging = true;
        hasMoved = false;
        startX = e.clientX;
        startY = e.clientY;
        slider.style.cursor = 'grabbing';
    });

    slider.addEventListener('mousemove', function(e) {
        if (!isDragging) return;

        // 移動距離を計算
        const deltaX = Math.abs(e.clientX - startX);
        const deltaY = Math.abs(e.clientY - startY);

        // 少しでも移動したらフラグを立てる
        if (deltaX > 5 || deltaY > 5) {
            hasMoved = true;
        }

        e.preventDefault();
    });

    slider.addEventListener('mouseup', function(e) {
        if (!isDragging) return;
        isDragging = false;
        endX = e.clientX;
        endY = e.clientY;
        slider.style.cursor = 'grab';
        handleSwipe();
    });

    slider.addEventListener('mouseleave', function() {
        if (isDragging) {
            isDragging = false;
            slider.style.cursor = 'grab';
        }
    });

    // カーソルスタイルの設定
    slider.style.cursor = 'grab';

    // 画像のドラッグを防止
    const allImages = slider.querySelectorAll('img');
    allImages.forEach(function(img) {
        img.addEventListener('dragstart', function(e) {
            e.preventDefault();
            return false;
        });
    });

    // リンクのドラッグを防止とクリック制御
    const allLinks = slider.querySelectorAll('a');
    allLinks.forEach(function(link) {
        link.addEventListener('dragstart', function(e) {
            e.preventDefault();
            return false;
        });

        // ドラッグ中のクリックを防止
        link.addEventListener('click', function(e) {
            if (hasMoved) {
                e.preventDefault();
                e.stopPropagation();
                return false;
            }
        });
    });

    function handleSwipe() {
        const deltaX = endX - startX;
        const deltaY = endY - startY;

        // 縦方向の移動が横方向より大きい場合はスクロールと判定してスワイプ処理をしない
        if (Math.abs(deltaY) > Math.abs(deltaX)) {
            return;
        }

        // 横方向のスワイプ判定
        if (Math.abs(deltaX) > minSwipeDistance) {
            if (deltaX > 0) {
                // 右にスワイプ/ドラッグ（前のスライドへ）
                updateSlide(currentIndex - 1);
            } else {
                // 左にスワイプ/ドラッグ（次のスライドへ）
                updateSlide(currentIndex + 1);
            }
        }
    }

    // 初期状態のボタンを更新
    updateButtons();
})();
